/* Esternal */
import { all, call, select } from "redux-saga/effects";

/* Actions */
import { baseActionName } from "./actions";

/* Services */
import { backendService } from "../../../services";

/* Utils */
import { makeFetchSaga } from "../../../utils";

function* fetchCategories() {
  const { data } = yield call(backendService.content.getStationCategories);
  return data || [];
}

function* fetchStationsByCategory(categoryId, useCase) {
  const { data } = yield call(backendService.content.getStationsByCategory, categoryId, useCase);
  return data.map(({ stationId = "" }) => stationId);
}

function getFilterData(filtersArray, filterId) {
  return filtersArray.find((filter) => filter.id === filterId);
}

function* setFilter(filterId) {
  const prevFilters = yield select(({ epg }) => epg?.filters?.data) || [];
  let newFilters = [],
    activeFilter = false,
    activeFilterData = {},
    activeFilterStations = [];

  if (!prevFilters.length) {
    const filters = yield fetchCategories() || [];
    activeFilterData = getFilterData(filters, filterId);
    activeFilterStations = yield fetchStationsByCategory(filterId, activeFilterData.useCase);

    newFilters = filters.map((filter) => {
      activeFilter = filter.id === filterId;
      return {
        id: filter.id,
        name: filter.name,
        useCase: filter.useCase,
        active: activeFilter,
        stations: activeFilter ? activeFilterStations : []
      };
    });
  } else {
    activeFilterData = getFilterData(prevFilters, filterId);
    activeFilterStations = activeFilterData?.stations?.length
      ? activeFilterData.stations
      : yield fetchStationsByCategory(filterId, activeFilterData.useCase);

    newFilters = prevFilters.map((filter) => {
      activeFilter = filter.id === filterId;

      return {
        ...filter,
        active: activeFilter,
        stations: activeFilter ? activeFilterStations : filter.stations
      };
    });
  }

  return { data: newFilters };
}

const filtersSaga = makeFetchSaga(baseActionName, {
  func: setFilter,
  getParams: (filterId) => [filterId]
});

export default function* epg() {
  yield all([filtersSaga]);
}
